
import React, { useState } from "react";
import "./Landing.css";
import axios from 'axios';
import PublicLayout from "layouts/Public";
import StickyNotificationBar from "components/Navbars/StickyNotificationBar";
import TabPanel from './TabPanel';
import {
    Tabs,
    Tab,
    AppBar,
    Toolbar,
    Divider,
    ListItemText,
    Typography,
    Button,
    Container,
    TextField,
    Grid,
    Box,
    Card,
    CardContent,
    CardActionArea,
    Link,
    Stack,
    Drawer,
    Paper,
    IconButton,
    Accordion,
    List,
    ListItemIcon,
    ListItem,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery,
    useTheme,
    CircularProgress
} from "@mui/material";
import DeliveryManImage from "../../assets/img/delivery-man.jpg";
import { styled } from '@mui/system';
import { NavigateNext } from '@mui/icons-material';
import MenuIcon from "@mui/icons-material/Menu";
import PhoneScreen from "../../assets/img/phone-main.png";
import womanOnPhone from "../../assets/img/woman-on-phone.png";
import ExplainerVideo from "../../assets/vid/explainer.mp4";
import One from "../../assets/img/1.png";
import Two from "../../assets/img/2.png";
import Three from "../../assets/img/3.png";
import Poster from "../../assets/img/Thumbnail8.png";
import Carousel from "react-material-ui-carousel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import FaceIcon from "@mui/icons-material/Face";
import PetsIcon from "@mui/icons-material/Pets";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import DownloadIcon from '@mui/icons-material/GetApp';
import MouseIcon from '@mui/icons-material/Mouse';
import EmailIcon from '@mui/icons-material/Email';
import { motion } from "framer-motion";
import { fadeInUp } from '../../utils/animations';
import FrontendNav from "components/Navbars/FrontendNav";
import FrontendFooter from "components/Footer/FrontendFooter";
import ServiceProviderGuideModal from "./ServiceProviderGuideModal"
import bikeImage from "../../assets/img/bike-image.webp";
import exerciseImage from "../../assets/img/exercise-image.webp";
import dogWalkImage from "../../assets/img/dog-walking.webp";
import Providers1 from "../../assets/img/Providers-01-scaled.webp";
import Providers2 from "../../assets/img/Providers-02-scaled.webp";
import Providers3 from "../../assets/img/Providers-03-scaled.webp";
import Providers4 from "../../assets/img/Providers-04-scaled.webp";
import Providers5 from "../../assets/img/Providers-05-scaled.webp";
import Customers6 from "../../assets/img/Customers-06-scaled.webp";
import Customers7 from "../../assets/img/Customers-07-scaled.webp";
import Customers8 from "../../assets/img/Customers-08-scaled.webp";
import Customers9 from "../../assets/img/Customers-09-scaled.webp";
import Customers10 from "../../assets/img/Customers-10-scaled.webp";
import Logo from "../../assets/img/Get_Sorted_Logo.webp";
import GetSortedUsers from "../../assets/img/Getsorted_Users_.webp";
import GooglePlayStore from "../../assets/img/Google-Play-Store.webp"
import AppleStore from "../../assets/img/Apple_Store.webp";
import ContactForm from "./ContactFormComponent"
import ApiClient from "../../api-client"

const banners = [
    {
        image: `${bikeImage}`,
        title: "Welcome to Get Sorted Services!",
        description: "Your trusted partner for professional services.",
    },
    {
        image: `${exerciseImage}`,
        title: "Experience Excellence",
        description: "We provide the best solutions for your needs.",
    },
    {
        image: `${dogWalkImage}`,
        title: "Reliable Services",
        description: "Trust us to get the job done right.",
    },
];

const TimelineCard = styled(Card)({
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    marginBottom: '16px',
    width: '100%',
    height: 'auto',
});

const TimelineContent = styled(Box)({
    marginLeft: '16px',
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 76px)',
});

const TimelineItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
});

const IconContainer = styled(Box)({
    width: '30px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const NumberIcon = styled(Box)({
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    backgroundColor: '#ea6d58',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '1',
    textAlign: 'center',
});

const TimelineLine = styled(Box)({
    height: '2px',
    backgroundColor: '#1976d2',
    flexGrow: 1,
});

const ListItemContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '20px',
});

const IconWrapper = styled(Box)({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#ea6d58',
    color: '#fff',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const InlineList = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    width: '100%',
});

const StepText = styled(Typography)({
    fontWeight: 'bold',
    fontSize: '16px',
    maxWidth: '200px',
});

const images = {
    customer: [
        `${Customers6}`,
        `${Customers7}`,
        `${Customers8}`,
        `${Customers9}`,
        `${Customers10}`
    ],
    serviceProvider: [
        `${Providers1}`,
        `${Providers2}`,
        `${Providers3}`,
        `${Providers4}`,
        `${Providers5}`
    ],
};

const customerSteps = [
    { number: 1, headline: 'Step 1', description: 'Fill out your info and create your password.' },
    { number: 2, headline: 'Step 2', description: 'Search and find services around your location.' },
    { number: 3, headline: 'Step 3', description: 'Choose a PROVIDER that suits your needs.' },
    { number: 4, headline: 'Step 4', description: 'Browse their details and if you are happy GET SORTED!' },
    { number: 5, headline: 'Step 5', description: 'Chat with your PROVIDER for final arrangements.' },
    { number: 6, headline: 'Step 6', description: 'Track your PROVIDER on GPS.' },
    { number: 7, headline: 'Step 7', description: 'Rate and review services and PROVIDERS.' },
    { number: 8, headline: 'Step 8', description: 'Manage your appointments and safely pay via the app. Money will be safely kept in escrow until the service is complete.' },
    { number: 9, headline: 'Step 9', description: 'Save your favourite PROVIDERS for a future date' },
];

const getServicesWithRibbon = (services) => {
    // List the services that should NOT have a coming soon ribbon.
    const exceptions = [
        "errand services",
        "driving services",
        "groceries",
        "personal shopping"
    ];

    // For each service, comingSoon is true unless its name matches an exception.
    return services.map((service) => ({
        name: service,
        comingSoon: !exceptions.includes(service.toLowerCase()),
    }));
};

const services = [
    "Electricians",
    "IT Services",
    "Professional Services",
    "Plumbers",
    "Handyman",
    "Cleaners",
    "Barbers",
    "Hairdressers",
    "Fitness Trainers",
    "Dog walker",
    "Dog-sitter",
    "Errand services",
    "Mountain Guides",
    "Personal Shopping",
    "Driving Services",
    "Groceries",
];

const servicesWithRibbon = getServicesWithRibbon(services);

const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: "#ea6d58",
    color: "#fff",
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "12px 24px",
    borderRadius: "8px",
    textTransform: "none",
    transition: "all 0.3s ease",
    "&:hover": {
        backgroundColor: "#d45a46",
        transform: "scale(1.05)",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    },
}));

// const handNewsL

const AnimatedButton = ({ children, ...props }) => {
    return (
        <StyledButton variant="contained" size="large" {...props}>
            {children}
        </StyledButton>
    );
};

const ServicesGrid = () => (
    <motion.div
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
    >
        <Box
            sx={{
                py: 8,
                px: 4,
                width: "100%",
                backgroundColor: "#ea6d58",
                color: "#ffffff",
            }}
        >
            <Container maxWidth="lg">
                { }
                <motion.div
                    variants={fadeInUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                >
                    <Typography
                        variant="h4"
                        gutterBottom
                        sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            mb: 6,
                        }}
                    >
                        Explore Our Services
                    </Typography>
                </motion.div>

                { }
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)" },
                        gap: 4,
                    }}
                >
                    {servicesWithRibbon.map((service, idx) => (
                        <motion.div
                            key={idx}
                            variants={fadeInUp}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    padding: "24px",
                                    backgroundColor: "#ffffff",
                                    color: "#000000",
                                    borderRadius: "20px",
                                    fontWeight: "bold",
                                    fontSize: "18px",
                                    boxShadow: 3,
                                    textAlign: "center",
                                    lineHeight: 1.5,
                                    transition: "transform 0.3s, box-shadow 0.3s",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: 6,
                                    },
                                }}
                            >
                                { }
                                {service.comingSoon && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "-10px",
                                            backgroundColor: "red",
                                            color: "#ffffff",
                                            fontWeight: "bold",
                                            fontSize: "12px",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            zIndex: 1,
                                        }}
                                    >
                                        Coming Soon
                                    </Box>
                                )}
                                {service.name}
                            </Box>
                        </motion.div>
                    ))}
                </Box>
            </Container>
        </Box>
    </motion.div>
);

const HomePage = () => {
    const theme = useTheme();
    const [openModal, setOpenModal] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [value, setValue] = useState(0);
    const [activeVerticalTab, setActiveVerticalTab] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const [formData, setFormData] = useState({ email: "" });
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    // Handle form submission
    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponseMessage("");

        try {
            // Fetch user's IP address from an external API
            const ipRes = await axios.get("https://api64.ipify.org?format=json");
            const ipAddress = ipRes.data.ip;

            // Send form data to your backend using your API client
            const res = await ApiClient.post('api/contact', { ...formData, ipAddress });

            if (res.success) {
                setResponseMessage("✅ Newsletter signup successfully!");
                setFormData({ email: "" }); // Reset form fields
            } else {
                setResponseMessage("❌ Failed to newsletter signup. Please try again.");
            }
        } catch (error) {
            console.error("❌ Error sending message:", error);
            setResponseMessage("❌ Error sending newsletter signup. Please try again.");
        }

        setLoading(false);
    };

    const serviceProviderSteps = [
        { number: 1, headline: 'Step 1', description: 'Fill in your information and create a password.' },
        { number: 2, headline: 'Step 2', description: 'Submit the relevant documentation.' },
        {
            number: 3,
            headline: 'Step 3',
            description: (
                <>
                    List your services and set your prices.{" "}
                    <span
                        style={{ color: "orange", cursor: "pointer", textDecoration: "none", fontWeight: "bold" }}
                        onClick={() => setOpenModal(true)}
                    >
                        CLICK HERE
                    </span>{" "}
                    for a step-by-step guide.
                </>
            )
        },
        { number: 4, headline: 'Step 4', description: 'Manage, message CUSTOMERS and book appointments.' },
        { number: 5, headline: 'Step 5', description: 'Chat with CUSTOMERS and complete appointments.Get paid once the job is complete.' },
        { number: 6, headline: 'Step 6', description: 'Set and manage your profile and availability, payments, banking details etc.' },
    ];

    const handleHorizontalChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleVerticalChange = (event, newValue) => {
        setActiveVerticalTab(newValue);
    };

    const steps = value === 0 ? customerSteps : serviceProviderSteps;
    const sliderImages = value === 0 ? images.customer : images.serviceProvider;

    return (
        <div>
            <StickyNotificationBar />
            <FrontendNav />
            <ServiceProviderGuideModal open={openModal} setOpenModal={setOpenModal} />
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Box
                    style={{
                        height: "100vh",
                        background: `
              linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3)),
              url(${DeliveryManImage})
            `,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundColor: "#121212",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#fff",
                        textAlign: "center",
                        padding: "16px",
                    }}
                >
                    { }
                    <img
                        className="centeredLogo"
                        src={Logo}
                        height="100px"
                        alt="Logo"
                    />

                    { }
                    <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
                        Get Sh*t Done!
                    </Typography>

                    { }
                    <Typography variant="h4">
                        Drop us your email to get notified when we launch the Get Sorted app.
                    </Typography>
                    { }
                    <Box
                        component="form"
                        onSubmit={handleNewsletterSubmit}
                        sx={{
                            mt: 4,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                            maxWidth: "600px",
                        }}
                    >
                        {/* Row for the input field and button */}
                        <Box sx={{ display: "flex", width: "100%" }}>
                            <TextField
                                variant="outlined"
                                placeholder="Enter your email address"
                                name="email"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                sx={{ flex: 1, mr: 2 }}
                            />
                            <Button
                                type="submit"
                                variant="contained"
                                style={{ backgroundColor: "#ea6d58" }}
                                size="large"
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Be The First"}
                            </Button>
                        </Box>

                        {responseMessage && (
                            <Typography variant="body1" sx={{ mt: 2, color: responseMessage.includes("✅") ? "green" : "red" }}>
                                {responseMessage}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </motion.div>

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Container sx={{ py: 10 }}>
                    <Grid container spacing={4}>
                        { }
                        {[
                            {
                                img: One,
                                title: "Become A Driver",
                                description: "Become a top-notch service professional with Get Sorted. Register to become a driver today.",
                                link: "https://forms.gle/c7CNXW6VqQd9ETxG8"
                            },
                            {
                                img: Two,
                                title: "Become A Service Provider",
                                description: "Join an array of businesses providing services to the Get Sorted clientele. Register to become a service provider today.",
                                link: "https://forms.gle/c7CNXW6VqQd9ETxG8"
                            },
                            {
                                img: Three,
                                title: "Become A Customer",
                                description: "Elevate your lifestyle with Get Sorted, saving you time and effort for daily tasks and needs.",
                                link: "https://forms.gle/RC1K2SrdF172AGQU9"
                            },
                        ].map((feature, idx) => (
                            <Grid item xs={12} md={4} key={idx}>
                                <Card sx={{
                                    border: "0px",
                                    boxShadow: "none",
                                    textAlign: "center"
                                }}>
                                    <CardActionArea>
                                        <CardContent>
                                            <Box
                                                component="img"
                                                src={feature.img}
                                                alt={`Feature ${idx + 1}`}
                                                sx={{
                                                    width: "100%",
                                                    height: "200px",
                                                    objectFit: "contain",
                                                    mb: 2,
                                                    border: "0px",
                                                    boxShadow: "none",
                                                    textAlign: "center"
                                                }}
                                            />
                                            <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
                                                {feature.title}
                                            </Typography>
                                            <Typography variant="body2">
                                                {feature.description}
                                            </Typography>
                                            <a className="btn btn-primary" style={{ background: "#121212" }} href={feature.link}>Signup</a>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </motion.div>

            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Container id="about" sx={{ py: 6 }}>
                    {/* Headline */}
                    <Typography
                        variant="h3"
                        sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            mb: 4,
                        }}
                    >
                        Your fastest way to get things done
                    </Typography>

                    {/* Center-Aligned Responsive Video */}
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Box
                            sx={{
                                position: "relative",
                                overflow: "hidden",
                                width: "100%",
                                maxWidth: "100%",
                                paddingTop: "56.25%",
                                borderRadius: "12px",
                            }}
                        >
                            <Box
                                component="video"
                                src={ExplainerVideo}
                                poster={Poster}
                                controls
                                loop
                                muted
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "12px",
                                    objectFit: "cover",
                                }}
                            />
                        </Box>
                    </Box>
                </Container>
            </motion.div>


            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Container id="about" sx={{ py: 6 }}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography variant="h4" sx={{ fontWeight: "bold" }} gutterBottom>
                                Get the app
                            </Typography>
                            <Typography variant="body1" paragraph>
                                At Get Sorted, we believe life’s too short to sweat the small stuff. That’s why we’ve created an app that lets you stay hands on, even when your hands are full. With the Get Sorted app, you’re just a tap away from trusted professionals ready to handle the tasks you don’t have time for. Whether it’s running errands, fixing things around the house, or finding someone to walk your dog, our app connects you to the services you need – fast.
                            </Typography>
                            <AnimatedButton
                                href="#contact"
                                rel="noopener noreferrer"
                            >
                                Learn More
                            </AnimatedButton>                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src={`${PhoneScreen}`}
                                alt="Get the App"
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </motion.div>

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Container sx={{ py: 6, position: "relative" }}>
                    { }
                    {/* <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: "-30%",
                            borderRadius: "20px",
                            width: "60%",
                            height: "100%",
                            backgroundColor: "#ea6d58",
                            zIndex: -1,
                        }}
                    /> */}

                    <Grid container spacing={4} alignItems="center" sx={{ position: "relative", zIndex: 2 }}>
                        <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                            <Box
                                component="img"
                                src={GetSortedUsers}
                                alt="Local Favorites"
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: 2,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: "bold" }} gutterBottom>
                                Get sh*t done
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Life moves fast, and so should your to-do list. With Get Sorted, you don’t have to waste time searching, scheduling, or second-guessing. We’ve built a network of reliable professionals who are ready when you are—no hassle, no headaches. Need a last-minute driver? A handyman for those home fixes? Someone to pick up your dry cleaning? Consider it done. Whatever’s on your plate, we help you clear it so you can focus on what really matters.
                            </Typography>
                            <AnimatedButton
                                href="#contact"
                                rel="noopener noreferrer"
                            >Explore Now</AnimatedButton>
                        </Grid>
                    </Grid>
                </Container>
            </motion.div>

            <motion.div>
                <Container sx={{ py: 6 }}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography variant="h4" sx={{ fontWeight: "bold" }} gutterBottom>
                                Get Sorted
                            </Typography>
                            <Typography variant="body1" paragraph>
                                We’re more than just an app—we’re a lifestyle upgrade. Get Sorted is here to simplify the everyday, making it easier to manage life’s demands with just a few taps. No more stress, no more endless lists—just seamless, on-demand solutions at your fingertips. Whether you’re a busy professional, a parent on the go, or someone who just needs a little extra help, we’ve got your back. Because when life gets busy, Get Sorted.                            </Typography>
                            <AnimatedButton
                                href="#contact"
                                rel="noopener noreferrer"
                            >Learn More</AnimatedButton>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box
                                component="img"
                                src={Customers9}
                                alt="Get the App"
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                </Container>
            </motion.div>


            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                id="errand-services"
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" },
                        gap: 4,
                        alignItems: "start",
                        py: 8,
                        px: 4,
                        backgroundColor: "#efefef", // White background
                        color: "#333",
                        position: "relative", // Ensure the container is a positioning context
                    }}
                >
                    { }
                    <Box
                        component="img"
                        src={`${womanOnPhone}`}
                        alt="Errand Service"
                        sx={{
                            width: { xs: "100%", sm: "100%", md: "50%" },
                            height: { xs: "auto", md: "100%" },
                            minHeight: { xs: "300px", md: "500px" },
                            borderRadius: "16px",
                            objectFit: "cover",
                            boxShadow: 3,
                        }}
                    />

                    { }
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: { xs: "100%", sm: "100%", md: "60%" },
                            borderRadius: "16px",
                            position: { xs: "static", md: "absolute" }, // Absolute positioning for overlap
                            left: { xs: 0, md: "40%" }, // Adjust overlap position
                            top: { xs: 0, md: "50%" }, // Adjust overlap position
                            transform: { xs: "none", md: "translateY(-50%)" }, // Center vertically
                            zIndex: 2, // Ensure it overlaps the image
                        }}
                    >
                        <Paper elevation={2} sx={{ p: 3, mx: 3, borderRadius: "16px" }}>
                            { }
                            <Typography
                                variant="h3"
                                sx={{
                                    mb: 4, // Add margin below the heading
                                    fontWeight: "bold",
                                    fontSize: { xs: "2rem", md: "2.5rem" }, // Responsive font size
                                    textAlign: { xs: "center", md: "left" }, // Center on mobile, left on desktop
                                }}
                            >
                                Get more done with us.
                            </Typography>

                            { }
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", md: "row" },
                                    width: "100%",
                                }}
                            >
                                { }
                                <Tabs
                                    value={activeVerticalTab}
                                    onChange={handleVerticalChange}
                                    textColor="inherit"
                                    orientation={isMobile ? "horizontal" : "vertical"}
                                    sx={{
                                        borderRight: isMobile ? "none" : 1,
                                        borderBottom: isMobile ? 1 : "none",
                                        borderColor: "divider",

                                        width: isMobile ? "100%" : "200px",
                                        backgroundColor: "transparent",
                                        borderRadius: "8px",

                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "#ea6d58",
                                            width: isMobile ? "100%" : "4px",
                                            right: isMobile ? "auto" : 0,
                                            bottom: isMobile ? 0 : "auto",
                                        },
                                    }}
                                // TabIndicatorProps={{
                                //   style: {
                                //     width: "4px",
                                //     right: 0,
                                //     backgroundColor: "#ea6d58",
                                //   }
                                // }}
                                >
                                    <Tab
                                        label="Errand Service Breakdown"
                                        sx={{
                                            width: "100%",
                                            minHeight: "60px",
                                            textAlign: "left",
                                            padding: "12px 16px",
                                            fontWeight: "bold",
                                            fontSize: "16px",

                                            color: activeVerticalTab === 0 ? "#ea6d58" : "#333",

                                            "&.Mui-selected": {
                                                color: "#ea6d58",
                                                borderRight: "none",
                                            },
                                        }}
                                    />
                                    <Tab
                                        label="Transport Service"
                                        sx={{
                                            width: "100%",
                                            minHeight: "60px",
                                            textAlign: "left",
                                            padding: "12px 16px",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            color: activeVerticalTab === 1 ? "#ea6d58" : "#333",
                                            "&.Mui-selected": {
                                                color: "#ea6d58",
                                                borderRight: "none",
                                            },
                                        }}
                                    />
                                    <Tab
                                        label="Package Delivery"
                                        sx={{
                                            width: "100%",
                                            minHeight: "60px",
                                            textAlign: "left",
                                            padding: "12px 16px",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            color: activeVerticalTab === 2 ? "#ea6d58" : "#333",
                                            "&.Mui-selected": {
                                                color: "#ea6d58",
                                                borderRight: "none",
                                            },
                                        }}
                                    />
                                </Tabs>


                                { }
                                <Box sx={{ flexGrow: 1, paddingLeft: { xs: 0, md: 4 } }}>
                                    <TabPanel value={activeVerticalTab} index={0}>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                                            Errand Shopping Service Breakdown
                                        </Typography>
                                        <Typography paragraph>
                                            This feature allows customers to order items from various stores
                                            not directly partnered with Get Sorted.
                                        </Typography>
                                        <ol>
                                            <li>Customer places an order specifying store and items.</li>
                                            <li>Cost estimate is generated for requested items.</li>
                                            <li>
                                                Customer pays the estimated total at checkout, including
                                                platform fees.
                                            </li>
                                            <li>Funds are allocated to the shopper’s card securely.</li>
                                            <li>Shopper purchases the items in-store.</li>
                                            <li>Real-time adjustments ensure accurate final costs.</li>
                                        </ol>
                                    </TabPanel>
                                    <TabPanel value={activeVerticalTab} index={1}>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                                            Errand Transport Service
                                        </Typography>
                                        <Typography paragraph>
                                            This service combines ride-sharing and parcel delivery. Users
                                            can:
                                        </Typography>
                                        <ul>
                                            <li>
                                                Request drivers to pick up themselves or others for transport.
                                            </li>
                                            <li>Request parcel delivery across multiple locations.</li>
                                            <li>Save trusted drivers for future trips.</li>
                                        </ul>
                                    </TabPanel>
                                    <TabPanel value={activeVerticalTab} index={2}>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
                                            Errand Package Delivery
                                        </Typography>
                                        <Typography paragraph>
                                            Standard parcel delivery with dynamic pricing based on:
                                        </Typography>
                                        <ul>
                                            <li>Time, distance, and parcel size.</li>
                                            <li>Value protection for items.</li>
                                            <li>Real-time tracking, messaging, and driver profiles.</li>
                                        </ul>
                                    </TabPanel>
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                </Box>
            </motion.div>

            { }
            <ServicesGrid />

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Box>
                    <Carousel>
                        {banners.map((banner, idx) => (
                            <Box
                                key={idx}
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%",
                                    // If you want some minimum height, you can set it here. E.g.:
                                    // minHeight: { xs: 300, md: 600 },
                                    // backgroundColor: "#000", // optional, in case the image is narrower
                                }}
                            >
                                <Box
                                    component="img"
                                    src={banner.image}
                                    alt={`Banner ${idx}`}
                                    sx={{
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                        // If you want a max height on desktop, you can do:
                                        // maxHeight: { xs: "none", md: 800 },
                                    }}
                                />
                            </Box>
                        ))}
                    </Carousel>
                </Box>
            </motion.div>

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Container
                    id="how-it-works"
                    maxWidth="lg"
                    sx={{ paddingTop: "75px", paddingBottom: "75px" }}
                >
                    <Typography
                        variant="h4"
                        gutterBottom
                        sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                        How it works
                    </Typography>

                    <Tabs
                        value={value}
                        onChange={handleHorizontalChange}
                        centered
                        sx={{
                            "& .MuiTabs-indicator": {
                                backgroundColor: "#ea6d58",
                            },
                            color: "#121212",
                        }}
                    >
                        <Tab
                            label="Customer"
                            sx={{
                                color: value === 0 ? "#121212" : "gray",
                                "&.Mui-selected": {
                                    color: "#121212",
                                },
                            }}
                        />
                        <Tab
                            label="Service Provider"
                            sx={{
                                color: value === 1 ? "#121212" : "gray",
                                "&.Mui-selected": {
                                    color: "#121212",
                                },
                            }}
                        />
                    </Tabs>

                    { }
                    {/* Desktop Layout */}
                    <Box
                        sx={{
                            display: { xs: "none", md: "flex" }, // Hide on mobile, show on desktop
                            justifyContent: "center",
                            marginTop: 2,
                        }}
                    >
                        { }
                        {/* Left Cards */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                width: "25%",
                                marginRight: "16px",
                                flexShrink: 0,
                                height: "100%",
                            }}
                        >
                            {steps.slice(0, value === 0 ? 5 : 3).map((step, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        width: "100%",
                                        padding: "16px",
                                        borderRadius: "8px",
                                        boxShadow: 3,
                                        mb: 2,
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                        <Box
                                            sx={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50%",
                                                backgroundColor: "#ea6d58",
                                                color: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {step.number}
                                        </Box>
                                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                            {step.headline}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{ mt: 2 }}>
                                        {step.description}
                                    </Typography>
                                </Card>
                            ))}
                        </Box>

                        { }
                        {/* Image Slider */}
                        <Box
                            sx={{
                                width: "50%",
                                maxWidth: "700px",
                                flexGrow: 1,
                            }}
                        >
                            <Swiper spaceBetween={10} slidesPerView={1} loop>
                                {sliderImages.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img
                                            src={img}
                                            alt={`Tab Image ${index + 1}`}
                                            style={{ width: "100%", height: "auto" }}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Box>

                        { }
                        {/* Right Cards */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                width: "25%",
                                marginLeft: "16px",
                                flexShrink: 0,
                                height: "100%",
                            }}
                        >
                            {steps.slice(value === 0 ? 5 : 3).map((step, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        width: "100%",
                                        padding: "16px",
                                        borderRadius: "8px",
                                        boxShadow: 3,
                                        mb: 2,
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                        <Box
                                            sx={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50%",
                                                backgroundColor: "#ea6d58",
                                                color: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {step.number}
                                        </Box>
                                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                            {step.headline}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{ mt: 2 }}>
                                        {step.description}
                                    </Typography>
                                </Card>
                            ))}
                        </Box>
                    </Box>

                    { }
                    {/* Mobile Layout */}
                    <Box
                        sx={{
                            display: { xs: "flex", md: "none" }, // Show on mobile, hide on desktop
                            flexDirection: "column", // Stack vertically
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: 2,
                            gap: 2, // Add gap between elements
                        }}
                    >
                        { }
                        {/* Image Slider */}
                        <Box
                            sx={{
                                width: "100%", // Full width on mobile
                                maxWidth: "700px",
                                flexGrow: 1,
                            }}
                        >
                            <Swiper spaceBetween={10} slidesPerView={1} loop>
                                {sliderImages.map((img, index) => (
                                    <SwiperSlide key={index}>
                                        <img
                                            src={img}
                                            alt={`Tab Image ${index + 1}`}
                                            style={{ width: "100%", height: "auto" }}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Box>

                        { }
                        {/* Cards */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column", // Stack vertically
                                justifyContent: "space-between",
                                width: "100%", // Full width on mobile
                                gap: 2, // Add gap between cards
                            }}
                        >
                            {steps.map((step, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        width: "100%", // Full width on mobile
                                        padding: "16px",
                                        borderRadius: "8px",
                                        boxShadow: 3,
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                        <Box
                                            sx={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50%",
                                                backgroundColor: "#ea6d58",
                                                color: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {step.number}
                                        </Box>
                                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                            {step.headline}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{ mt: 2 }}>
                                        {step.description}
                                    </Typography>
                                </Card>
                            ))}
                        </Box>
                    </Box>
                </Container>
            </motion.div>

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <ContactForm />
            </motion.div>

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Box
                    sx={{
                        py: 8,
                        px: 4,
                        width: "100%",
                        backgroundColor: "grey.100",
                    }}
                >
                    <Container maxWidth="lg">
                        <Typography
                            variant="h5"
                            gutterBottom
                            sx={{
                                textAlign: "center",
                                fontWeight: "bold",
                                mb: 6,
                                color: "text.primary",
                            }}
                        >
                            Frequently asked questions
                        </Typography>

                        <Box>
                            {[
                                {
                                    question: "What is Get Sorted?",
                                    answer:
                                        "Get Sorted is an app that connects you with trusted professionals to help you handle everyday tasks like errands, home maintenance, and pet care.",
                                },
                                {
                                    question: "How do I book a service?",
                                    answer:
                                        "You can book a service by signing in to the app, selecting your desired service category, and scheduling a professional at your convenience.",
                                },
                                {
                                    question: "Are the professionals verified?",
                                    answer:
                                        "Yes, all professionals on Get Sorted are thoroughly vetted to ensure safety and quality of service.",
                                },
                                {
                                    question: "What payment methods are accepted?",
                                    answer:
                                        "We accept all major credit cards and payment methods, including Apple Pay and Google Pay.",
                                },
                                {
                                    question: "Is there customer support available?",
                                    answer:
                                        "Absolutely! Our support team is available 24/7 to assist you with any issues or inquiries.",
                                },
                            ].map((faq, index) => (
                                <Accordion
                                    key={index}
                                    sx={{
                                        mb: 2,
                                        borderRadius: 1,
                                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "white",
                                        overflow: "hidden",
                                        "&:before": { display: "none" },
                                        "&.Mui-expanded": {
                                            margin: 0,
                                        },
                                    }}
                                >
                                    <AccordionSummary
                                        expandIcon={
                                            <span
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "28px",
                                                    height: "28px",
                                                    backgroundColor: "#ea6d58",
                                                    color: "white",
                                                    borderRadius: "50%",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                &#9662;
                                            </span>
                                        }
                                        aria-controls={`faq-${index}-content`}
                                        id={`faq-${index}-header`}
                                        sx={{
                                            backgroundColor: "white",
                                            "&.Mui-expanded": {
                                                backgroundColor: "white",
                                            },
                                            padding: "8px 12px",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontWeight: "medium",
                                                color: "text.primary",
                                            }}
                                        >
                                            {faq.question}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails
                                        sx={{
                                            backgroundColor: "white",
                                            padding: "16px",
                                            borderTop: "1px solid #f0f0f0",
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                                            {faq.answer}
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </Box>
                    </Container>
                </Box>
            </motion.div>

            { }
            <motion.div
                variants={fadeInUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <Box
                    sx={{
                        textAlign: "center",
                        width: "100%",
                        marginTop: "0px",
                        paddingTop: "60px",
                        paddingBottom: "60px",
                        marginBottom: "0px",
                        backgroundColor: "white",
                        zIndex: -1,
                    }}
                >
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
                        Download the Get Sorted App
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Get the app today and start tackling your to-do list with ease. Available
                        on the Apple App Store and Google Play.
                    </Typography>
                    <Box
                        sx={{
                            mt: 4,
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" }, // Stack vertically on mobile, inline on desktop
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 2, // Add gap between buttons
                        }}
                    >
                        <Box
                            component="a"
                            href="https://apps.apple.com/"
                            target="_blank"
                            sx={{
                                display: "inline-block",
                                width: { xs: "100%", md: "auto" }, // Full width on mobile, auto width on desktop
                                textAlign: "center", // Center the image
                            }}
                        >
                            <Box
                                component="img"
                                src={AppleStore}
                                alt="Download on the App Store"
                                sx={{
                                    maxWidth: { xs: "200px", md: "200px" },
                                    height: "auto",
                                }}
                            />
                        </Box>
                        <Box
                            component="a"
                            href="https://play.google.com/store"
                            target="_blank"
                            sx={{
                                display: "inline-block",
                                width: { xs: "100%", md: "auto" }, // Full width on mobile, auto width on desktop
                                textAlign: "center", // Center the image
                            }}
                        >
                            <Box
                                component="img"
                                src={GooglePlayStore}
                                alt="Get it on Google Play"
                                sx={{
                                    maxWidth: { xs: "200px", md: "200px" },
                                    height: "auto",
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </motion.div>
            <FrontendFooter />
        </div >
    );
};

export default HomePage;
